//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Column, Row, TitleSection } from "components/styles";
import { AboutSchedule, Container, Content, ScheduleCard } from "../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import { CustomRadio } from "components/CustomRadio/CustomRadio";
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import { getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import { MONTHS, WEEK_DAYS } from "components/CustomDatePicker/utils/helpers";
//#endregion
//#region Icons
import LocationIcon from "icons/LocationIcon";
import RemoteIcon from "icons/RemoteIcon";
import TimerIcon from "icons/TimerIcon";
import CalendarIcon from "icons/CalendarIcon";
//#endregion
//#region Services
import { requestReassignReservation } from "services/employability";
//#endregion
//#region Utils
import { LOADING_MESSAGES } from "../../Popups/constants";
import useMainContext from "utils/context/useMainContext";
//#endregion

const getFormattedDate = timestamp => {
    const dateObj = new Date(timestamp)
    const dayName = WEEK_DAYS[dateObj.getDay()].substring(0, 3);
    const monthName = MONTHS[dateObj.getMonth()].substring(0, 3);
    return `${dayName}, ${dateObj.getDate()} ${monthName} ${dateObj.getFullYear()}`;
}

const DialogUpcomingSchedulesReassignment = ({
    show, toggleShow, setLoadingService,
    toggleShowDialogUpcomingSuccessfulReassignment,
    schedules, reservation, currentSchedule,
    setCurrentUpcomingSchedule,
    isPresential
}) => {
    const mainContext = useMainContext();
    //#region States
    const [errorMessage, setErrorMessage] = useState("");
    //#endregion
    //#region Functions
    const reassignSchedule = async () => {
        toggleShow(false);
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.UPDATE
        };
        setLoadingService({ ...newLoadingService });
        const response = await requestReassignReservation({
            reservationId: reservation.id, 
            appointmentDateId: currentSchedule.appointmentDateId, 
            timeStart: currentSchedule.time.start,
            timeEnd: currentSchedule.time.end
        });
        setLoadingService({ ...newLoadingService, loading: false });
        // Verificando si la reasignación se completo con éxito
        if (response.success) toggleShowDialogUpcomingSuccessfulReassignment();
        else if (response.message) setErrorMessage(response.message);
        else mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return (
        <>
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={() => toggleShow(false)}
            variant="reassignment">
            <CloseButton onClick={() => toggleShow(false)}/>
            <Column align="center" 
                gap="24px"
                marginTop="46px">
                <TitleSection 
                    width="100%"
                    textAlign="center" 
                    fontWeight="900" 
                    margin="0">Horarios disponibles más cercanos</TitleSection>
                <Container>
                    <Content>
                        {schedules.map((props, idx) => {
                            const { time, date, ...restProps } = props;
                            const timeStr = getTextByRangeMinutes(time);
                            const dateStr = getFormattedDate(date);
                            const checked = props.appointmentDateId === currentSchedule.appointmentDateId && props.time === currentSchedule.time;
                            return (
                                <ScheduleItem 
                                    key={idx}
                                    {...restProps}
                                    timeStr={timeStr}
                                    dateStr={dateStr}
                                    checked={checked}
                                    isPresential={isPresential}
                                    onChange={() => setCurrentUpcomingSchedule({
                                        ...props,
                                        dateStr, timeStr
                                    })}/>
                            );
                        })}
                    </Content>
                </Container>
                <Row width="100%" justifyContent="center" gap="16px">
                    <CustomButton 
                        variant="secondary" 
                        size="medium" 
                        width="87px"
                        text="Cancelar"
                        onClick={() => toggleShow(false)}/>
                    <CustomButton 
                        size="medium" 
                        width="82px"
                        disabled={!currentSchedule?.appointmentDateId}
                        text="Agregar"
                        onClick={reassignSchedule}/>
                </Row>
            </Column>
        </DialogAlert>
        <DialogAlertAction
            show={!!errorMessage}
            toggleShow={() => setErrorMessage("")}
            close={() => setErrorMessage("")}
            variant="error"
            title="No se pudo reasignar"
            content={errorMessage}>
            <CustomButton
                size="medium"
                width="100px"
                text="Cerrar"
                onClick={() => setErrorMessage("")}/>
        </DialogAlertAction>
        </>
    );
}

const ScheduleItem = ({
    checked,
    onChange,
    isPresential,
    adviser,
    dateStr, timeStr
}) => {
    return (
        <ScheduleCard>
            <CustomRadio 
                label={adviser.name}
                checked={checked}
                onChange={onChange}
                fontSizeLabel="14px"/>
            <AboutSchedule>
                {isPresential 
                ? <Row gap="7px">
                    <LocationIcon size={18}/>
                    <span>Lugar</span>
                </Row>
                : <Row gap="7px">
                    <RemoteIcon size={16}/>
                    <span>Zoom</span>
                </Row>}
                <Row gap="7px">
                    <CalendarIcon size={16}/>
                    <span>{dateStr}</span>
                </Row>
                <Row gap="7px">
                    <TimerIcon size={16}/>
                    <span>{timeStr}</span>
                </Row>
            </AboutSchedule>
        </ScheduleCard>
    );
}

export default DialogUpcomingSchedulesReassignment;
